import { Play, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import QuizzyLogo from "./QuizzyLogo";

export default function Navbar({ playstoreUrl }) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 pt-4">
      <nav className="glass mx-auto flex max-w-6xl items-center justify-between rounded-2xl px-4 sm:px-6 py-3">
        <a href="#top" data-testid="nav-brand-logo" className="flex items-center gap-3">
          <QuizzyLogo size={36} />
          <span className="font-display text-lg font-bold tracking-wide">QUIZZY</span>
        </a>
        <div className="hidden md:flex items-center gap-8 font-sub text-sm text-[#94A3B8]">
          <a href="#chapters" className="link-underline hover:text-white transition-colors">Chapters</a>
          <a href="#play" className="link-underline hover:text-white transition-colors">Play</a>
          <a href="#notify" className="link-underline hover:text-white transition-colors">Notify Me</a>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/admin"
            data-testid="nav-admin-toggle-button"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#222738] text-[#64748B] transition-colors hover:border-[#00F0FF] hover:text-[#00F0FF]"
            aria-label="Admin"
          >
            <Lock size={15} />
          </Link>
          <a
            href={playstoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-playstore-button"
            className="btn-neon flex items-center gap-2 rounded-full bg-[#00F0FF] px-4 sm:px-5 py-2 font-sub text-sm font-semibold text-[#08090E]"
          >
            <Play size={14} fill="currentColor" />
            <span className="hidden sm:inline">Get the App</span>
            <span className="sm:hidden">Get</span>
          </a>
        </div>
      </nav>
    </header>
  );
}
